export default __webpack_public_path__ + "static/media/Close-small.b84d102d.svg";